module.exports = __webpack_public_path__ + "static/media/data-security.62a9ebbb.jpg";